'use client'

import Image from 'next/image'

type Payload = {
   width: number
   height: number
}

export const LogoHorizontal = (payload: Payload) => {
   return (
      <Image
         alt={'Clean Park Logo Horizontal'}
         src={`/logo.svg`}
         {...payload}
      />
   )
}
